const API_BASE_URL = `${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0`;

export const TIME_SLOTS = [
  "08:00 - 09:00",
  "09:00 - 10:00",
  "10:00 - 11:00",
  "13:00 - 14:00",
  "14:00 - 15:00",
  "15:00 - 16:00",
  "16:00 - 17:00",
];

// Map DoctorMobileDto (backend) -> shape DoctorCard expects
const mapDoctor = (d) => ({
  id: d.id,
  name: d.name,
  specialty: d.specialityName,
  title: d.isExpert ? "Bác sỹ chuyên gia" : "",
  avatar: d.avatarUrl,
  room: d.hospitalName || d.address,
  description: "",
});

export const settingsService = {
  async getBanners() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/CustomerPortal/banner/get-all`,
      );
      if (response.ok) {
        const json = await response.json();
        // { Data: [{ id, title, subtitle, image, linkUrl }] } -> json.data
        if (Array.isArray(json.data) && json.data.length > 0) {
          return json.data;
        }
      }
    } catch {
      // API chưa sẵn sàng, dùng dữ liệu mẫu
    }
    return [];
  },

  async getDoctors() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/CustomerPortal/doctor/get-all`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            skip: 0,
            take: 50,
            query: { freeText: null, isExpert: false },
          }),
        },
      );
      if (response.ok) {
        const json = await response.json();
        // { Data: { Data: [...] } } -> camelCase: json.data.data
        const list = json?.data?.data;
        if (Array.isArray(list) && list.length > 0) {
          return list.map(mapDoctor);
        }
      }
    } catch {
      // API chưa sẵn sàng, dùng dữ liệu mẫu
    }
    return [];
  },

  async getHospitals() {
    try {
      const response = await fetch(
        `${API_BASE_URL}/CustomerPortal/hospital/get-all`,
      );
      if (response.ok) {
        const json = await response.json();
        if (Array.isArray(json.data) && json.data.length > 0) {
          return json.data;
        }
      }
    } catch {
      // API chưa sẵn sàng
    }
    return [];
  },

  getTimeSlots() {
    return TIME_SLOTS;
  },
};
